import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface AlertStylesProps {
  background: string;
  fullWidth: boolean;
}

const useStyles = makeStyles<Theme, AlertStylesProps>(theme => ({
  container: {
    backgroundColor: props => props.background,
    borderRadius: theme.spacing(0.5),
    display: props => (props.fullWidth ? 'flex' : 'inline-flex'),
    padding: theme.spacing(1, 1.5),
  },
  content: {
    '& > img': {
      marginRight: theme.spacing(1),
    },
    '& > svg': {
      marginRight: theme.spacing(1),
    },
    display: 'flex',
    margin: 'auto',
    width: 'unset',
  },
  message: {
    minWidth: 0,
    width: '100%',
  },
}));

export default useStyles;
